/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ModelKeyProvider, LocaleProvider } from '@typescript-kit/core';
import { AuthenticationModelKey } from './key/authentication-model.key';
import { Credentials } from './model/credentials.model';
import { User } from './model/user.model';

// DYNAMIC IMPORT IS NOT WORKING WITH COMMONJS MODULE RESOLUTION
import { authenticationDeLocale } from './locale/de.locale';
import { authenticationEnLocale } from './locale/en.locale';

export class AuthenticationInitializer {

  static initialize() {
    AuthenticationInitializer.registerModelKeys();
    AuthenticationInitializer.registerLocales();
  }

  static registerModelKeys() {
    ModelKeyProvider.registerKey(Credentials, AuthenticationModelKey.CREDENTIALS);
    ModelKeyProvider.registerKey(User, AuthenticationModelKey.USER);
  }

  static registerLocales() {
    LocaleProvider.registerPackageLocale('de', 'kit-authentication', authenticationDeLocale);
    LocaleProvider.registerPackageLocale('en', 'kit-authentication', authenticationEnLocale);
  }

}
